import React, { useState, ReactNode, useEffect } from 'react';
import AudienceCsvStatusContainer from './csv_status';
import PageAccessSearchField from '../../components/manage/page_access_search_field';
import { Status } from './csv_status';
import { Urls } from './types';
import FeatureCallout from 'components/feature_callout';
import { Body, Link } from './styles';
import notify, { Color } from 'utils/notify';

interface Props {
  pageId: string;
  userId: string;
  organizationId: string;
  initialStatus: Status | null;
  urls: Urls;
  filestackKey: string;
  trialPage: boolean;
  showCallout: boolean;
}

export default function AudienceSpecificHeader({
  pageId,
  userId,
  organizationId,
  initialStatus,
  urls,
  filestackKey,
  trialPage,
  showCallout,
}: Props) {
  const [status, setStatus] = useState(initialStatus);
  const [genericError, setGenericError] = useState(false);

  function csvActionsDisabled() {
    return status && !status.csv_actions_enabled;
  }

  function notifyIfImportDisabled() {
    if (csvActionsDisabled()) {
      notify(
        `You are unable to add new users while an ${
          status!.csv_display_mode
        } is in progress. Try again when the ${
          status!.csv_display_mode
        } is finished.`,
        {
          color: Color.ERROR,
        },
      );
    }
  }

  function performExport() {
    if (csvActionsDisabled()) {
      notify(
        `You are unable to export while an ${
          status!.csv_display_mode
        } is in progress. Try again when the ${
          status!.csv_display_mode
        } is finished.`,
        {
          color: Color.ERROR,
        },
      );
      return;
    }

    $.ajax({
      type: 'POST',
      url: urls.processExport,
      success: function(data) {
        setStatus(data);
      },
      error: function() {
        setGenericError(true);
      },
    });
  }

  const options = (
    <span className="dropdown pau-actions right-of-title">
      <button
        className="dropdown-toggle"
        data-toggle="dropdown"
        id="audience-options-dropdown"
      >
        <span className="dropdown-toggle-text">Options</span>
        <span className="dropdown-toggle-icon fa fa-angle-down"></span>
      </button>
      <ul className="dropdown-menu right-align">
        <li>
          <a
            href={csvActionsDisabled() ? '#' : '#modal-import-users'}
            data-toggle="modal"
            onClick={notifyIfImportDisabled}
          >
            Import users
          </a>
        </li>
        <li>
          <a href="#" onClick={performExport}>
            Export all users
          </a>
        </li>
      </ul>
    </span>
  );

  function renderOptions() {
    const spotlightBody = (
      <Body>
        You can now import and export users in bulk using a CSV file.
        <br />
        <Link href="https://help.statuspage.io/help/import-audience-specific-users">
          Learn more
        </Link>
      </Body>
    );

    if (!showCallout) return options;

    return (
      <FeatureCallout
        userId={userId}
        organizationId={organizationId}
        featureName="csv_magic"
        spotlightHeading="Import users with CSV"
        spotlightBody={spotlightBody}
      >
        {options}
      </FeatureCallout>
    );
  }

  return (
    <>
      <div className="pull-right audience-header-right">
        <div className="search-box">
          <PageAccessSearchField pageId={pageId} />
        </div>
        {renderOptions()}
      </div>

      {
        // Since the above div is floating content, this will clear the floats so that
        // the elements that come next will actually render below.
      }
      <div className="clearfix"></div>

      <AudienceCsvStatusContainer
        status={status}
        setStatus={setStatus}
        genericError={genericError}
        setGenericError={setGenericError}
        urls={urls}
        filestackKey={filestackKey}
        trialPage={trialPage}
      />
    </>
  );
}
